import React from "react";
import { Link } from "react-router-dom";
import { FaAtom, FaLaptopCode, FaBuilding, FaBolt, FaTools, FaSatelliteDish, FaCogs, FaDumbbell } from "react-icons/fa";
import DepartmentAdmin from './DepartmentAdmin';  // Import the new DepartmentAdmin component
import '../../styles/departments.css';

const Departments = () => {
  const departments = [
    { name: "Basic Science", icon: <FaAtom />, path: "/admin/basicscience" },
    { name: "Computer Science", icon: <FaLaptopCode />, path: "/admin/computerscience" },
    { name: "Civil Engineering", icon: <FaBuilding />, path: "/admin/civilengineering" },
    { name: "Electrical Engineering", icon: <FaBolt />, path: "/admin/electricalengineering" },

    { name: "Electronics & Communication", icon: <FaSatelliteDish />, path: "/admin/electronicsengineering" },
    { name: "Mechanical Engineering", icon: <FaCogs />, path: "/admin/mechanicalengineering" },
    { name: "Physical Education", icon: <FaDumbbell />, path: "/admin/physicaleducation" },
  ];

  return (
    <div className="departments-container">
      <h2>Departments</h2>
      <div className="departments-grid">
        {departments.map((dept) => (
          <Link key={dept.name} to={dept.path} className="department-card">
            <div className="icon">{dept.icon}</div>
            <div className="name">{dept.name}</div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Departments;
